import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { theme } from './theme/theme';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
//import CountdownPage from './pages/CountdownPage';

function App() {
  const childProps = {
    isAuthenticated: true,
    userRole: "admin"
  };
  /*return (
    <CountdownPage />
  );*/
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 0,
            mt: 8,
            color: '#fff',
          }}
        >
            <Router childProps={childProps} />
        </Box>
        <Footer />
      </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;